module.exports = __webpack_public_path__ + "static/media/4554.a839b453.jpg";